import { z } from "zod";

export const competencyStatusValues = ["draft", "active", "archived"] as const;
export type CompetencyStatus = (typeof competencyStatusValues)[number];

// Field set WITHOUT the status default — the base for both variants. zod's
// .partial() still applies .default() values for absent keys, so a defaulted
// update schema would re-inject status:"draft" into every partial edit. The
// default lives only on create.
const competencyFieldsSchema = z.object({
  name: z.string().min(1, "Name is required").max(120),
  description: z.string().max(2000).nullable().optional(),
  /**
   * The categories this competency is in — the whole set, replacing whatever
   * it was in. Absent means "leave membership alone", which is what every
   * caller that predates the category/theme merge sends.
   */
  categoryIds: z.array(z.string().uuid()).optional(),
  status: z.enum(competencyStatusValues),
});
export const competencyCreateSchema = competencyFieldsSchema.extend({
  status: z.enum(competencyStatusValues).default("draft"),
});
export const competencyUpdateSchema = competencyFieldsSchema.partial();
export type CompetencyCreateInput = z.infer<typeof competencyCreateSchema>;
export type CompetencyUpdateInput = z.infer<typeof competencyUpdateSchema>;
